import { render, staticRenderFns } from "./chart-selection.vue?vue&type=template&id=0c936f85"
import script from "./chart-selection.vue?vue&type=script&lang=js"
export * from "./chart-selection.vue?vue&type=script&lang=js"
import style0 from "./chart-selection.vue?vue&type=style&index=0&id=0c936f85&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports